
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";

/**
 * Service for fetching user profile information
 */
export const profileQueryService = {
  /**
   * Get a user profile by ID
   * @param userId The ID of the user to fetch
   * @returns The user profile or null if not found
   */
  getUserProfile: withErrorHandling(
    async (userId: string): Promise<any> => {
      console.log('Fetching user profile for ID:', userId);
      
      try {
        // With new RLS policies, we can directly query the profile
        // Include created_at for account age calculation
        const { data, error } = await supabase
          .from('profiles')
          .select('id, first_name, last_name, family_role, registration_family_id, current_family_id, created_at')
          .eq('id', userId)
          .single();
        
        if (error) {
          console.error('Error fetching profile:', error);
          if (error.code === 'PGRST116') {
            // No rows returned - profile doesn't exist or no access
            return null;
          }
          throw error;
        }
        
        console.log('Profile data found:', data);
        return data;
      } catch (error) {
        console.error('Unexpected error in getUserProfile:', error);
        throw error;
      }
    },
    "Error fetching user profile"
  )
};
